export default __webpack_public_path__ + "024d1a0627779c1b463f4a3fee166e8f.svg";